import { lazy } from "react";

// Route-level code splitting: each screen is its own JS chunk, so the first load only
// downloads the app shell + the screen being opened instead of the whole app.
const loaders = [];
const RELOAD_KEY = "ff_chunk_reload";

function load(loader) {
  return loader()
    .then((mod) => {
      try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* ignore */ }
      return mod;
    })
    .catch((err) => {
      // After a deploy the old hashed chunks are gone: reload once to pick up the new build.
      let reloaded = false;
      try { reloaded = sessionStorage.getItem(RELOAD_KEY) === "1"; } catch { /* ignore */ }
      if (!reloaded && /Loading (CSS )?chunk|ChunkLoadError/i.test(String(err?.name) + String(err?.message))) {
        try { sessionStorage.setItem(RELOAD_KEY, "1"); } catch { /* ignore */ }
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    });
}

export function lazyPage(loader) {
  loaders.push(loader);
  return lazy(() => load(loader));
}

// Once the current screen has loaded and the browser is idle, fetch the other screens in
// the background so later navigation is instant. Skipped on data-saver connections.
export function prefetchPages() {
  // Automated browsers (the CI load-time test) measure each screen on its own.
  if (navigator.webdriver) return;
  const conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ""))) return;
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  let i = 0;
  const next = () => {
    if (i >= loaders.length) return;
    loaders[i++]().catch(() => {}).finally(() => idle(next));
  };
  const start = () => setTimeout(() => idle(next), 3000);
  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
}
